import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type IconProps = Partial<SVGIconProps>;

const AlertCircleIcon: FC<IconProps> = ({ color = "#F04438", ...props }) => (
  <SVGIcon
    fill="none"
    viewBox="0 0 45 46"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M39.1303 22.6454C39.1303 13.3526 31.6846 5.81927 22.4999 5.81927C13.3152 5.81927 5.86948 13.3526 5.86948 22.6454C5.86948 31.9381 13.3152 39.4714 22.4999 39.4714C31.6846 39.4714 39.1303 31.9381 39.1303 22.6454ZM22.518 28.2541C23.5385 28.2541 24.3658 29.0911 24.3658 30.1236C24.3658 31.1561 23.5385 31.9932 22.518 31.9932H22.4999C21.4794 31.9932 20.6521 31.1561 20.6521 30.1236C20.6521 29.0911 21.4794 28.2541 22.4999 28.2541H22.518ZM20.6521 22.6454V15.1671C20.6521 14.1346 21.4794 13.2975 22.4999 13.2975C23.5204 13.2975 24.3477 14.1346 24.3477 15.1671V22.6454C24.3477 23.6779 23.5204 24.5149 22.4999 24.5149C21.4794 24.5149 20.6521 23.6779 20.6521 22.6454ZM42.826 22.6454C42.826 34.0032 33.7257 43.2106 22.4999 43.2106C11.2741 43.2106 2.17383 34.0032 2.17383 22.6454C2.17383 11.2875 11.2741 2.08014 22.4999 2.08014C33.7257 2.08014 42.826 11.2875 42.826 22.6454Z"
      fill={color}
    />
  </SVGIcon>
);

export default AlertCircleIcon;
